import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "../../context/AxiosInstance";
import Swal from "sweetalert2";
import "../../styles/rh-modern-ui.css";

const CrgFormModal = ({ show, handleClose, isEditMode, selectedCrg, token, refreshData }) => {
  const [formData, setFormData] = useState({
    code_crg: "",
    libelle_crg: "",
    prise_en_charge_crg: "",
    type_crg: "", // ✅ Ajouté ici
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // 🌀 Initialisation du formulaire
  useEffect(() => {
    if (isEditMode && selectedCrg) {
      setFormData({
        code_crg: selectedCrg.code_crg || "",
        libelle_crg: selectedCrg.libelle_crg || "",
        prise_en_charge_crg: selectedCrg.prise_en_charge_crg || "",
        type_crg: selectedCrg.type_crg || "", // ✅ ici aussi
      });
    } else {
      setFormData({
        code_crg: "",
        libelle_crg: "",
        prise_en_charge_crg: "",
        type_crg: "", // ✅ vide par défaut
      });
    }
    setErrors({});
  }, [show, isEditMode, selectedCrg]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.code_crg) newErrors.code_crg = "Code requis";
    if (!formData.libelle_crg) newErrors.libelle_crg = "Libellé requis";
    if (!formData.prise_en_charge_crg) newErrors.prise_en_charge_crg = "Champ requis";
    if (!formData.type_crg) newErrors.type_crg = "Type requis"; // ✅ ajout de validation
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const valErrors = validate();
    if (Object.keys(valErrors).length > 0) {
      setErrors(valErrors);
      return;
    }

    setLoading(true);
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      if (isEditMode) {
        await axios.patch(
          `/crg/${selectedCrg.id_crg}`,
          formData,
          config
        );
        Swal.fire("Modifié ✅", "", "success");
      } else {
        await axios.post("/crg/", formData, config);
        Swal.fire("Ajouté ✅", "", "success");
      }

      refreshData();
      handleClose();
    } catch (err) {
      Swal.fire("Erreur ❌", "Échec de l'enregistrement", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static" className="rh-modern-modal">
      <Modal.Header closeButton className="rh-modal-header rh-modal-header-contract">
        <Modal.Title>{isEditMode ? "Modifier" : "Ajouter"} une rubrique CRG</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body className="rh-modal-body">
          <Form.Group className="mb-3">
            <Form.Label>Code *</Form.Label>
            <Form.Control
              name="code_crg"
              value={formData.code_crg}
              onChange={handleChange}
              isInvalid={!!errors.code_crg}
            />
            <Form.Control.Feedback type="invalid">
              {errors.code_crg}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Libellé *</Form.Label>
            <Form.Control
              name="libelle_crg"
              value={formData.libelle_crg}
              onChange={handleChange}
              isInvalid={!!errors.libelle_crg}
            />
            <Form.Control.Feedback type="invalid">
              {errors.libelle_crg}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Prise en charge *</Form.Label>
            <Form.Select
              name="prise_en_charge_crg"
              value={formData.prise_en_charge_crg}
              onChange={handleChange}
              isInvalid={!!errors.prise_en_charge_crg}
            >
              <option value="">-- Choisir --</option>
              <option value="Salariale">Salariale</option>
              <option value="Patronale">Patronale</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.prise_en_charge_crg}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Type *</Form.Label>
            <Form.Select
              name="type_crg"
              value={formData.type_crg}
              onChange={handleChange}
              isInvalid={!!errors.type_crg}
            >
              <option value="">-- Choisir --</option>
              <option value="1_Brut">1_Brut</option>
               <option value="2_Taxe">2_Taxe</option>
              <option value="3_Cotisation">3_Cotisation</option>
              <option value="4_Pret">4_Pret</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.type_crg}
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="rh-modal-footer">
          <Button variant="secondary" onClick={handleClose}>
            Annuler
          </Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : isEditMode ? "Modifier" : "Ajouter"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CrgFormModal;
